/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{Uniform as r}from"./Uniform.js";class o extends r{constructor(r){super(r,"vec3")}}export{o as Float3Uniform};
